//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../Header";
//Install
import Footer from "../../Footer";
//Install
import T723BA from "../../../../../Media/Image/031.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Davamlılıq : Temas Elektrik Müqaviləsi"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik, Davamlı və Etibarlı Enerji Xidmətləri ilə Hər Toxunuş Gələcəyə Dəyər Qatar."
        //Element
        let URL = "https://temaselektrik.com/az/davamliliq"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB yh70s1" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Davamlılıq"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Davamlı Enerji, ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "Yaşana Bilən "
                                        ),
                                        //Element
                                        "Dünya"
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u m-0" },
                                        //Element
                                        "Temas Elektrik Müqaviləsi, Təqdim Etdiyi Xidmətləri İcra Edərkən Ətraf Mühit, Sosial Və İqtisadi Məsuliyyətləri Əsas Prioritet Kimi Qəbul Edir."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Planetimizi Qorumaq Və Gələcək Nəsillərə Yaşana Bilən Bir Dünya Buraxmaq Məqsədilə Enerji Həllərində Səmərəlilik Və Davamlılığı Əsas Tuturuq."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Yenilənə Bilən Enerji Mənbələrindən Maksimum Səmərə Sağlamaq, Enerji İstehsal Və İstifadə Proseslərini Optimallaşdırmaq Və Layihələrimizi Ətraf Mühitə Dost Texnologiyalarla Gerçəkləşdirmək, Davamlılıq Anlayışımızın Təmasını Təşkil Edir."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Həmçinin, Bütün Xidmətlərimizdə Davamlı Material İstifadəsi, Enerji Qənaəti Və Tullantı İdarəetməsi Sahələrində Ən Yaxşı Təcrübələri Mənimsəyərək, Müştərilərimizə Yalnız Etibarlı Deyil, Eyni Zamanda Ətraf Mühitə Həssas Həllər Təqdim Edirik."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik olaraq; Davamlı Dəyərləri Qorumaq Və Mənbələri Gələcək Nəsillərə Çatdırmaq Məsuliyyətini Bütün Layihələrində Və Xidmətlərində Gerçəkləşdirir."
                                    )
                                )
                            )
                        )
                    )
                ),
                //Element
                React.createElement(Footer, {})
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;